
































import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { createDigitsArr } from '@/tools/counters';

@Component
export default class EnergyCounterSvg extends Vue {
  @Prop({ default: 'кВт·ч' }) private Metric!: string;

  @Prop({ required: true }) private Digits!: string;

  @Prop({ required: true }) private Unit!: string;

  private readonly DigitsArr: Array<string> = createDigitsArr(this.Digits, this.Digits.length - 1);
}
